import DatasheetForm from '../../../components/datasheet/Form'

export default {
  components: {
    DatasheetForm
  }
}
